<article class="wrapper fsn-big-tab-tab" [style.grid-column]="'span ' + span">
  <div class="checkmark"><mat-icon svgIcon="checkmark"></mat-icon></div>
  <div *ngIf="comingSoon" class="coming-soon">COMING SOON</div>
  <section class="content">
    <h3>{{ name }}</h3>
    <ng-content></ng-content>
  </section>
</article>
<ng-content select="fsn-databox" />
